import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import BoxEmpty from "../boxDetials/boxEmpty";
import { deleteCart, fetchMyCarts } from "../../redux/reducer/cartReducer";
import LoadingSpinner from "../animation/LoadingSpinner";
import CustomOrderInstructionCard from "./customOrderInstructionCard";
import CustomBanner from "../boxDetials/customBanner";
import CustomBuyForMeCard from "../buyForMe/customBuyForMeCard";
import GalleryPopup from "../sharedComponents/GalleryPopup";
import InvoiceIcon from "../sharedComponents/InvoiceIcon";

const CustomBuyForMeCardList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [selectedIds, setSelectedIds] = useState([]);
  const roundToTwo = (num) => parseFloat(Number(num).toFixed(2));
  const [showGalleryPopup, setShowGalleryPopup] = useState(null);

  const { carts, cartsLoading, cartsError } = useSelector(
    (state) => state.carts
  );

  useEffect(() => {
    dispatch(fetchMyCarts());
  }, [dispatch]);

  const handleDelete = (cartId) => {
    dispatch(deleteCart(cartId));
  };

  if (cartsLoading) {
    return <LoadingSpinner />;
  }

  const beforeReceivedCarts =
    carts?.filter(
      (cart) => cart.status === "purchased" || cart.status === "requested"
      // (cart) => cart.status === "received"
    ) || [];

  if (beforeReceivedCarts.length === 0 || cartsError) {
    return <BoxEmpty title="EmptyBox" />;
  }
  // console.log(beforeReceivedCarts)

  const openEditForm = (item) => {};
  const openShowGallery = (item) => {
    setShowGalleryPopup(item);
  };
  return (
    <div className="">
      {beforeReceivedCarts.map((cart) => (
        <div key={cart._id} className="flex flex-col gap-4 ">
          <CustomBanner
            orderNumber={cart.referenceCode}
            cartId={cart._id}
            products={cart.products}
            area={
              cart.area === "67dfef98100f542a2c700c08" ? "Europe" : "Turkey"
            }
          />

          <div className="grid items-center w-full grid-cols-2 gap-2 mt-4 lg:gap-4 md:grid-cols-3 ">
            {cart.products && cart.products.length > 0 ? (
              cart.products.map((product) => (
                <div key={product._id}>
                  <CustomBuyForMeCard
                    image={
                      product.img ||
                      "https://api.markaship.com/uploads/waiting.png"
                    }
                    title={
                      product.name === "Waiting..."
                        ? { en: "Waiting...", ar: "انتظر..." }
                        : product.name
                    }
                    size={product.additionalInfo || "N/A"}
                    link={product.link}
                    count={product.count || "1"}
                    price={roundToTwo(Number(product.price) * Number(product.count)) || "0.00"}
                    status={product.status || "pending"}
                    timeLeft={product.timeLeft || "0"}
                    isEditable={false}
                    checked={selectedIds.includes(product._id)}
                    del={() => handleDelete(product._id)}
                    onEdit={() => openEditForm(product)}
                    onShowGallery={() => openShowGallery(product.imgs)}
                    images={product.imgs}
                  />
                </div>
              ))
            ) : (
              <p>{t("NoProductsInCart")}</p>
            )}
          </div>

          <div className="flex justify-between w-full my-4">
            <div className="flex flex-col w-1/2 lg:w-1/3">
              <span className="mb-1 font-medium text-gray-500 ms-2">
                {t("status")}
              </span>
              <div className="p-4 bg-white border rounded-md">
                <span className="text-sm font-bold text-black lg:text-lg">
                  {t(`${cart.status}`)}
                </span>
              </div>
            </div>

            <div className="flex items-end justify-end w-1/2 lg:w-1/3">
              <button
                onClick={() => window.open(`${cart.paymentPDF}`, "_blank")}
                className={`bg-black text-white py-2 px-2 lg:py-3 lg:px-6 rounded-custom
                    text-xs  lg:text-sm inline-flex items-center justify-center
                    transition duration-300 ease-in-out transform hover:scale-105 
                    focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color 
                    whitespace-nowrap`}
              >
                {t("invoice")}
                <InvoiceIcon bgColor={"white"} />
              </button>
            </div>
          </div>
        </div>
      ))}
      <div className=" lg:w-[60%] mx-auto">
        <CustomOrderInstructionCard title={t("WaitingReceived")} />
      </div>
      {showGalleryPopup && (
        <GalleryPopup
          images={showGalleryPopup}
          onClose={() => setShowGalleryPopup(null)}
        />
      )}
    </div>
  );
};

export default CustomBuyForMeCardList;
